import React, { useState, useEffect, useRef } from "react";
import ReactGA from "react-ga";

import { phoneLogin, phoneSendPin, phoneVerifyPin } from "../store/actions/homeActions";

import { connect } from "react-redux";
import { compose } from "redux";

import { Link, Redirect } from "react-router-dom";

import { languageService } from "./lang/Lang.js";

// True when the current hostname is the UAE variant (uae.sahra.ai or dev-uae.sahra.ai)
const isUAESite = () => {
  if (typeof window === "undefined") return false;
  return /(^|\.)uae\.sahra\.ai$/i.test(window.location.hostname) ||
         /(^|\.)dev-uae\.sahra\.ai$/i.test(window.location.hostname);
};

// Normalize a raw UAE phone input to "971XXXXXXXXX". Returns null if invalid.
// Mirrors the server-side normalizeUAEPhone in backend/pigu-clean.js.
const normalizeUAEPhone = (raw) => {
  if (!raw) return null;
  let s = String(raw).trim().replace(/[^\d+]/g, "");
  if (s.startsWith("+")) s = s.slice(1);
  if (s.startsWith("00971")) s = s.slice(5);
  else if (s.startsWith("971")) s = s.slice(3);
  if (s.startsWith("0")) s = s.replace(/^0+/, "");
  s = "971" + s;
  if (!/^9715\d{8}$/.test(s)) return null;
  return s;
};

const COUNTRIES = [
  { code: "CH", dial: "41", flag: "\u{1F1E8}\u{1F1ED}", name: "Switzerland" },
  { code: "SA", dial: "966", flag: "\u{1F1F8}\u{1F1E6}", name: "Saudi Arabia" },
  { code: "AE", dial: "971", flag: "\u{1F1E6}\u{1F1EA}", name: "UAE" },
  { code: "DE", dial: "49", flag: "\u{1F1E9}\u{1F1EA}", name: "Germany" },
  { code: "FR", dial: "33", flag: "\u{1F1EB}\u{1F1F7}", name: "France" },
  { code: "IT", dial: "39", flag: "\u{1F1EE}\u{1F1F9}", name: "Italy" },
  { code: "AT", dial: "43", flag: "\u{1F1E6}\u{1F1F9}", name: "Austria" },
  { code: "GB", dial: "44", flag: "\u{1F1EC}\u{1F1E7}", name: "United Kingdom" },
  { code: "US", dial: "1", flag: "\u{1F1FA}\u{1F1F8}", name: "United States" },
  { code: "ES", dial: "34", flag: "\u{1F1EA}\u{1F1F8}", name: "Spain" },
  { code: "PT", dial: "351", flag: "\u{1F1F5}\u{1F1F9}", name: "Portugal" },
  { code: "NL", dial: "31", flag: "\u{1F1F3}\u{1F1F1}", name: "Netherlands" },
  { code: "BE", dial: "32", flag: "\u{1F1E7}\u{1F1EA}", name: "Belgium" },
  { code: "SE", dial: "46", flag: "\u{1F1F8}\u{1F1EA}", name: "Sweden" },
  { code: "NO", dial: "47", flag: "\u{1F1F3}\u{1F1F4}", name: "Norway" },
  { code: "DK", dial: "45", flag: "\u{1F1E9}\u{1F1F0}", name: "Denmark" },
  { code: "FI", dial: "358", flag: "\u{1F1EB}\u{1F1EE}", name: "Finland" },
  { code: "PL", dial: "48", flag: "\u{1F1F5}\u{1F1F1}", name: "Poland" },
  { code: "CZ", dial: "420", flag: "\u{1F1E8}\u{1F1FF}", name: "Czech Republic" },
  { code: "GR", dial: "30", flag: "\u{1F1EC}\u{1F1F7}", name: "Greece" },
  { code: "TR", dial: "90", flag: "\u{1F1F9}\u{1F1F7}", name: "Turkey" },
  { code: "RU", dial: "7", flag: "\u{1F1F7}\u{1F1FA}", name: "Russia" },
  { code: "EG", dial: "20", flag: "\u{1F1EA}\u{1F1EC}", name: "Egypt" },
  { code: "MA", dial: "212", flag: "\u{1F1F2}\u{1F1E6}", name: "Morocco" },
  { code: "TN", dial: "216", flag: "\u{1F1F9}\u{1F1F3}", name: "Tunisia" },
  { code: "DZ", dial: "213", flag: "\u{1F1E9}\u{1F1FF}", name: "Algeria" },
  { code: "LB", dial: "961", flag: "\u{1F1F1}\u{1F1E7}", name: "Lebanon" },
  { code: "JO", dial: "962", flag: "\u{1F1EF}\u{1F1F4}", name: "Jordan" },
  { code: "IQ", dial: "964", flag: "\u{1F1EE}\u{1F1F6}", name: "Iraq" },
  { code: "KW", dial: "965", flag: "\u{1F1F0}\u{1F1FC}", name: "Kuwait" },
  { code: "QA", dial: "974", flag: "\u{1F1F6}\u{1F1E6}", name: "Qatar" },
  { code: "BH", dial: "973", flag: "\u{1F1E7}\u{1F1ED}", name: "Bahrain" },
  { code: "OM", dial: "968", flag: "\u{1F1F4}\u{1F1F2}", name: "Oman" },
  { code: "YE", dial: "967", flag: "\u{1F1FE}\u{1F1EA}", name: "Yemen" },
  { code: "LY", dial: "218", flag: "\u{1F1F1}\u{1F1FE}", name: "Libya" },
  { code: "SD", dial: "249", flag: "\u{1F1F8}\u{1F1E9}", name: "Sudan" },
  { code: "PS", dial: "970", flag: "\u{1F1F5}\u{1F1F8}", name: "Palestine" },
  { code: "SY", dial: "963", flag: "\u{1F1F8}\u{1F1FE}", name: "Syria" },
  { code: "IN", dial: "91", flag: "\u{1F1EE}\u{1F1F3}", name: "India" },
  { code: "PK", dial: "92", flag: "\u{1F1F5}\u{1F1F0}", name: "Pakistan" },
  { code: "BR", dial: "55", flag: "\u{1F1E7}\u{1F1F7}", name: "Brazil" },
  { code: "CA", dial: "1", flag: "\u{1F1E8}\u{1F1E6}", name: "Canada" },
  { code: "AU", dial: "61", flag: "\u{1F1E6}\u{1F1FA}", name: "Australia" },
  { code: "RS", dial: "381", flag: "\u{1F1F7}\u{1F1F8}", name: "Serbia" },
  { code: "BG", dial: "359", flag: "\u{1F1E7}\u{1F1EC}", name: "Bulgaria" },
  { code: "HR", dial: "385", flag: "\u{1F1ED}\u{1F1F7}", name: "Croatia" },
  { code: "BA", dial: "387", flag: "\u{1F1E7}\u{1F1E6}", name: "Bosnia" },
  { code: "RO", dial: "40", flag: "\u{1F1F7}\u{1F1F4}", name: "Romania" },
  { code: "HU", dial: "36", flag: "\u{1F1ED}\u{1F1FA}", name: "Hungary" },
  { code: "IL", dial: "972", flag: "\u{1F1EE}\u{1F1F1}", name: "Israel" },
  { code: "LI", dial: "423", flag: "\u{1F1F1}\u{1F1EE}", name: "Liechtenstein" },
];

function PhoneLogin(props) {
  const { loggedin, errore, phoneLoginFN, phoneSendPinFN, phoneVerifyPinFN } = props;
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(COUNTRIES[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);
  const searchRef = useRef(null);

  // UAE variant state — only meaningful when isUAESite() is true.
  const [uaeStep, setUaeStep] = useState("number"); // "number" | "code"
  const [uaePin, setUaePin] = useState("");
  const [uaeNormalized, setUaeNormalized] = useState(null);
  const [uaeLocalError, setUaeLocalError] = useState(null);

  const uaeMode = isUAESite();

  const handleUAESubmitNumber = async (e) => {
    e.preventDefault();
    setUaeLocalError(null);
    const normalized = normalizeUAEPhone(phoneNumber);
    if (!normalized) {
      setUaeLocalError(languageService.translate("phone_login.uae_invalid"));
      return;
    }
    ReactGA.event({ category: "User", action: "PhoneLogin_UAE_SendPin" });
    setLoading(true);
    const ok = await phoneSendPinFN(normalized);
    setLoading(false);
    if (ok) {
      setUaeNormalized(normalized);
      setUaeStep("code");
    }
  };

  const handleUAESubmitCode = async (e) => {
    e.preventDefault();
    setUaeLocalError(null);
    if (!/^\d{4}$/.test(uaePin)) {
      setUaeLocalError(languageService.translate("phone_login.uae_pin_invalid"));
      return;
    }
    ReactGA.event({ category: "User", action: "PhoneLogin_UAE_VerifyPin" });
    setLoading(true);
    await phoneVerifyPinFN(uaeNormalized, uaePin);
    setLoading(false);
  };

  const handleUAEResend = async () => {
    setUaeLocalError(null);
    setUaePin("");
    setLoading(true);
    await phoneSendPinFN(uaeNormalized);
    setLoading(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (dropdownOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [dropdownOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();

    ReactGA.event({
      category: "User",
      action: "PhoneLogin",
    });

    const fullNumber = selectedCountry.dial + phoneNumber.replace(/^0+/, "");
    setLoading(true);
    phoneLoginFN(fullNumber);
  };

  // Stop loading when we get an error back
  if (errore && loading) {
    setLoading(false);
  }

  const getErrorMessage = () => {
    if (!errore) return null;
    if (errore === "no_subscription") {
      return languageService.translate("phone_login.no_sub");
    }
    return languageService.translate("phone_login.error");
  };

  const filteredCountries = COUNTRIES.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.dial.includes(search) ||
      c.code.toLowerCase().includes(search.toLowerCase())
  );

  const selectCountry = (country) => {
    setSelectedCountry(country);
    setDropdownOpen(false);
    setSearch("");
  };

  if (loggedin) return <Redirect to="/chat" />;

  if (uaeMode) {
    return (
      <div className="container" style={{ marginTop: "60px" }}>
        <div
          className="columns"
          style={{ margin: 13, background: "white", borderRadius: "3px" }}
        >
          <div className="column" style={{ color: "black", padding: "10px !important" }}>
            {uaeStep === "number" ? (
              <form onSubmit={handleUAESubmitNumber}>
                <div style={{ height: "10px" }} />
                <p><b>{languageService.translate("phone_login.title")}</b></p>
                <div style={{ height: "5px" }} />
                <p style={{ color: "#666", fontSize: "0.9em" }}>
                  {languageService.translate("phone_login.uae_subtitle")}
                </p>
                <div style={{ height: "15px" }} />

                <div className="field">
                  <div style={{ display: "flex", alignItems: "stretch" }}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "8px 12px",
                        fontSize: "1.1em",
                        lineHeight: 1,
                        background: "#f8f9fa",
                        border: "1px solid #dbdbdb",
                        borderRight: "none",
                        borderRadius: "4px 0 0 4px",
                        color: "#4b6385",
                        whiteSpace: "nowrap",
                        userSelect: "none",
                      }}
                    >
                      <svg width="22" height="15" viewBox="0 0 24 16" aria-label="UAE" style={{ display: "block", borderRadius: "2px" }}>
                        <rect width="6" height="16" fill="#EF3340" />
                        <rect x="6" width="18" height="5.34" fill="#00732F" />
                        <rect x="6" y="5.33" width="18" height="5.34" fill="#fff" />
                        <rect x="6" y="10.66" width="18" height="5.34" fill="#000" />
                      </svg>
                      <span style={{ fontWeight: "500", lineHeight: 1, display: "inline-flex", alignItems: "center" }}>+971</span>
                    </span>
                    <input
                      required
                      autoFocus
                      className="input"
                      type="tel"
                      inputMode="numeric"
                      placeholder={languageService.translate("phone_login.uae_placeholder")}
                      value={phoneNumber}
                      onChange={(v) => setPhoneNumber(v.target.value)}
                      style={{
                        color: "#4b6385",
                        fontSize: "1.2em",
                        borderRadius: "0 4px 4px 0",
                        flex: 1,
                        minWidth: 0,
                      }}
                    />
                  </div>
                </div>

                <div className="field">
                  <button
                    disabled={loading}
                    style={{
                      padding: "10px 15px",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      border: 0,
                      color: "#fff",
                      background: loading ? "#ccc" : "#F35875",
                      borderRadius: "3px",
                      cursor: loading ? "not-allowed" : "pointer",
                    }}
                  >
                    {loading
                      ? languageService.translate("phone_login.loading")
                      : languageService.translate("phone_login.uae_send_button")}
                  </button>
                </div>

                {uaeLocalError && <p style={{ color: "red" }}>{uaeLocalError}</p>}
                {errore && !uaeLocalError && (
                  <p style={{ color: "red" }}>
                    {languageService.translate("phone_login.uae_send_error")}
                  </p>
                )}
              </form>
            ) : (
              <form onSubmit={handleUAESubmitCode}>
                <div style={{ height: "10px" }} />
                <p><b>{languageService.translate("phone_login.uae_code_title")}</b></p>
                <div style={{ height: "5px" }} />
                <p style={{ color: "#666", fontSize: "0.9em" }}>
                  {languageService.translate("phone_login.uae_code_subtitle")} +{uaeNormalized}
                </p>
                <div style={{ height: "15px" }} />

                <div className="field">
                  <input
                    required
                    autoFocus
                    className="input"
                    type="tel"
                    inputMode="numeric"
                    maxLength={4}
                    pattern="\d{4}"
                    placeholder="1234"
                    value={uaePin}
                    onChange={(v) => setUaePin(v.target.value.replace(/\D/g, ""))}
                    style={{
                      color: "#4b6385",
                      fontSize: "1.4em",
                      letterSpacing: "0.4em",
                      textAlign: "center",
                    }}
                  />
                </div>

                <div className="field">
                  <button
                    disabled={loading}
                    style={{
                      padding: "10px 15px",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      border: 0,
                      color: "#fff",
                      background: loading ? "#ccc" : "#F35875",
                      borderRadius: "3px",
                      cursor: loading ? "not-allowed" : "pointer",
                    }}
                  >
                    {loading
                      ? languageService.translate("phone_login.loading")
                      : languageService.translate("phone_login.uae_verify_button")}
                  </button>
                </div>

                {uaeLocalError && <p style={{ color: "red" }}>{uaeLocalError}</p>}
                {errore && !uaeLocalError && (
                  <p style={{ color: "red" }}>
                    {languageService.translate("phone_login.uae_verify_error")}
                  </p>
                )}

                <div style={{ height: "10px" }} />
                <p style={{ fontSize: "0.9em" }}>
                  <button
                    type="button"
                    onClick={handleUAEResend}
                    disabled={loading}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#F35875",
                      cursor: loading ? "not-allowed" : "pointer",
                      padding: 0,
                      textDecoration: "underline",
                    }}
                  >
                    {languageService.translate("phone_login.uae_resend")}
                  </button>
                  {"  ·  "}
                  <button
                    type="button"
                    onClick={() => { setUaeStep("number"); setUaePin(""); setUaeLocalError(null); }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#666",
                      cursor: "pointer",
                      padding: 0,
                      textDecoration: "underline",
                    }}
                  >
                    {languageService.translate("phone_login.uae_change_number")}
                  </button>
                </p>
              </form>
            )}

            <div style={{ height: "20px" }} />
            <p>
              {languageService.translate("phone_login.alt")}{" "}
              <Link to="/login" style={{ color: "#F35875" }}>
                {languageService.translate("phone_login.alt_link")}
              </Link>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ marginTop: "60px" }}>
      <div
        className="columns"
        style={{ margin: 13, background: "white", borderRadius: "3px" }}
      >
        <div
          className="column"
          style={{ color: "black", padding: "10px !important" }}
        >
          <form onSubmit={handleSubmit}>
            <div style={{ height: "10px" }}></div>

            <p>
              <b>{languageService.translate("phone_login.title")}</b>
            </p>
            <div style={{ height: "5px" }}></div>
            <p style={{ color: "#666", fontSize: "0.9em" }}>
              {languageService.translate("phone_login.subtitle")}
            </p>
            <div style={{ height: "15px" }}></div>

            <div className="field">
              <div style={{ display: "flex", alignItems: "stretch", gap: "0px" }}>
                {/* Country selector */}
                <div ref={dropdownRef} style={{ position: "relative" }}>
                  <button
                    type="button"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      height: "100%",
                      padding: "8px 12px",
                      fontSize: "1.1em",
                      background: "#f8f9fa",
                      border: "1px solid #dbdbdb",
                      borderRight: "none",
                      borderRadius: "4px 0 0 4px",
                      cursor: "pointer",
                      color: "#4b6385",
                      whiteSpace: "nowrap",
                      transition: "background 0.2s",
                    }}
                  >
                    <span style={{ fontSize: "1.3em" }}>{selectedCountry.flag}</span>
                    <span style={{ fontWeight: "500" }}>+{selectedCountry.dial}</span>
                    <span style={{ fontSize: "0.7em", marginLeft: "2px", opacity: 0.6 }}>&#9660;</span>
                  </button>

                  {dropdownOpen && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        zIndex: 1000,
                        width: "300px",
                        maxHeight: "320px",
                        background: "white",
                        border: "1px solid #dbdbdb",
                        borderRadius: "8px",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                        marginTop: "4px",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                        <input
                          ref={searchRef}
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder={languageService.translate("phone_login.search_country") || "Search..."}
                          style={{
                            width: "100%",
                            padding: "8px 12px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "6px",
                            fontSize: "0.95em",
                            outline: "none",
                            color: "#333",
                            boxSizing: "border-box",
                          }}
                        />
                      </div>
                      <div style={{ overflowY: "auto", maxHeight: "260px" }}>
                        {filteredCountries.map((country) => (
                          <div
                            key={country.code}
                            onClick={() => selectCountry(country)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              padding: "10px 14px",
                              cursor: "pointer",
                              background:
                                selectedCountry.code === country.code
                                  ? "#fff0f3"
                                  : "transparent",
                              transition: "background 0.15s",
                              borderBottom: "1px solid #f5f5f5",
                            }}
                            onMouseEnter={(e) => {
                              if (selectedCountry.code !== country.code)
                                e.currentTarget.style.background = "#f8f9fa";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background =
                                selectedCountry.code === country.code
                                  ? "#fff0f3"
                                  : "transparent";
                            }}
                          >
                            <span style={{ fontSize: "1.3em" }}>{country.flag}</span>
                            <span style={{ flex: 1, color: "#333", fontSize: "0.95em" }}>
                              {country.name}
                            </span>
                            <span
                              style={{
                                color: "#888",
                                fontSize: "0.9em",
                                fontWeight: "500",
                              }}
                            >
                              +{country.dial}
                            </span>
                          </div>
                        ))}
                        {filteredCountries.length === 0 && (
                          <div style={{ padding: "16px", color: "#999", textAlign: "center" }}>
                            {languageService.translate("phone_login.no_results") || "No results"}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Phone input */}
                <input
                  required
                  className="input"
                  type="tel"
                  placeholder={languageService.translate(
                    "phone_login.placeholder"
                  )}
                  value={phoneNumber}
                  onChange={(v) => setPhoneNumber(v.target.value)}
                  style={{
                    color: "#4b6385",
                    fontSize: "1.2em",
                    borderRadius: "0 4px 4px 0",
                    flex: 1,
                    minWidth: 0,
                  }}
                />
              </div>
            </div>

            <div className="field">
              <button
                disabled={loading}
                style={{
                  padding: "10px 15px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  border: 0,
                  color: "#fff",
                  background: loading ? "#ccc" : "#F35875",
                  borderRadius: "3px",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                {loading
                  ? languageService.translate("phone_login.loading")
                  : languageService.translate("phone_login.button")}
              </button>
            </div>

            {errore ? (
              <p style={{ color: "red" }}>{getErrorMessage()}</p>
            ) : null}
          </form>

          <div style={{ height: "20px" }}></div>
          <p>
            {languageService.translate("phone_login.alt")}{" "}
            <Link to="/login" style={{ color: "#F35875" }}>
              {languageService.translate("phone_login.alt_link")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errore: state.home.errore,
    loggedin: state.home.loggedin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    phoneLoginFN: (phone_number) => dispatch(phoneLogin(phone_number)),
    phoneSendPinFN: (phone_number) => dispatch(phoneSendPin(phone_number)),
    phoneVerifyPinFN: (phone_number, pin) => dispatch(phoneVerifyPin(phone_number, pin)),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(PhoneLogin);
